<template>
  <div class="container" v-if="isLoggedIn">
    <!-- 서브상단영역 -->
    <Banner
      title="Activity"
      subtitle="Activity"
      description="학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>
        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    />
    <!-- //서브상단영역 -->

    <BoardNavbar />

    <div class="width_wrap">
      <div class="body_content">
        <!-- 서브 타이틀영역 -->
        <h1 class="sub_subject">꿈 창업 프로젝트</h1>
        <!-- //서브 타이틀영역 -->

        <div class="menu-A-read-wrap">
          <div>
            <ul class="line line4">
              <li>꿈·창업 프로젝트</li>
              <li>
                <dl class="line2">
                  <dt>제목</dt>
                  <dd>재능 발견으로 꿈을 창업하다!</dd>
                </dl>
              </li>
            </ul>
          </div>
          <div>
            <ul>
              <li>
                <figure>
                  <n-space justify="center">
                    <img
                      src="@/assets/thum_img/kp708b/sub4_2/9ad8852443a2316a93fbbd9e94758324_water__c1_w280_h397.jpg"
                      alt=""
                    />
                  </n-space>
                </figure>
              </li>
              <li>
                <dl>
                  <dt>목적</dt>
                  <dd>
                    학생이 자신의 재능, 관심, 꿈을 탐색, 실현하는 창업 계획 수립
                    활동을 통해<br />
                    자기 이해와 함께 미래에 나아갈 자신의 세상을 경험하는 기회를
                    제공한다.
                  </dd>
                </dl>

                <dl>
                  <dt>목표</dt>
                  <dd>
                    ① 개별적으로 관심 직업군을 선택하고, 함께 일하고 싶은 또래와
                    팀을 구성한다.
                    <br />
                    ② 팀 구성원들과 의논하여 창업 아이템을 선정하고 그에 따른
                    직무를 브레인스토밍, 분류한다.<br />
                    ③ 사업을 위한 구체적인 계획을 수립하고, 과업 공고문을
                    토대로, 창업계획서를 작성한다. <br />
                    ④ 팀 발표 및 심사에 따른 공간/지원금 결정으로, 공간 설계도
                    및 가구 배치도를 제작하여 최종산출물을 완성한다.
                  </dd>
                </dl>

                <dl>
                  <dt>대상</dt>
                  <dd>중1 – 중3</dd>
                </dl>

                <dl class="line2">
                  <dt>시간</dt>
                  <dd>3시간</dd>
                </dl>
              </li>
            </ul>
          </div>

          <div>
            <ul class="line line4">
              <li>팀 과제</li>
              <li>
                <dl class="line2">
                  <dt>재료</dt>
                  <dd>
                    • 자료 1. 직업군 16종: (카드) 명칭 + 이미지 + 직무 목록
                    (1인1장)<br />
                    • 자료 2. 과업 지시문: 복합창업공간지원사업 모집 공고문 +
                    공간 설계도<br />
                    • 자료 3. 사업제안서 양식: 창업개요(w.1) + 사업자/구성원
                    소개(w.2) + 과업내용 구성(w.3) + 공간/예산청구(w.4)
                  </dd>
                </dl>
              </li>
            </ul>
          </div>

          <div>
            <ul class="line">
              <li>
                결과물<br />
                + 결과리포트<br />
                + 공간설계도 및 가구 배치도
              </li>
              <li>
                <dl class="line2">
                  <dt>구성</dt>
                  <dd>
                    • 모듈 1. [강의] (1) 21세기 직업군의 이해, (2) 프로그램 소개
                    및 안전 교육<br />
                    • 모듈 2. 관심 직업군 선택 >> 팀 조직(1인~4인/팀)/직무 확인
                    >> 창업 아이템 논의/선정 >> 역할 분류<br />
                    • 모듈 3. 창업 계획 및 창업계획서 작성<br />
                    • 모듈 4. 발표 – 심사 >> 공간 위치 및 지원금 결정 >> 팀별
                    공간 설계도 및 가구 배치도 제작
                  </dd>
                </dl>
              </li>
            </ul>
          </div>

          <div>
            <ul class="line">
              <li>진행: 관리자</li>
              <li>
                <dl class="line2">
                  <dt>활용</dt>
                  <dd></dd>
                </dl>
              </li>
            </ul>
          </div>

          <div class="btn">
            <router-link :to="`${USER_ROUTES.Product.Activity.Startup.Path}`"
              >목록</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import BoardNavbar from "@/views/product/activity/Navbar.vue";
import Banner from "@/components/Banner.vue";

import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";
const useAlert = useAlertDialog();
const { isLoggedIn } = useAuth();
const router = useRouter();
watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.sub_title_01 p {
  position: absolute;
  top: 70px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 30px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 600;
}
.sub_title_01 h2 {
  position: absolute;
  top: 130px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
}

.menu-A-read-wrap * {
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  word-break: keep-all;
  box-sizing: border-box;
}
.menu-A-read-wrap > div h1 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 30px;
  text-align: center;
}
.menu-A-read-wrap > div ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.menu-A-read-wrap > div ul.box22 {
  padding: 20px 0;
}
.menu-A-read-wrap > div ul li {
  width: 100%;
  font-size: 14px;
  line-height: 1.7em;
}

.menu-A-read-wrap > div ul li:nth-child(1) {
  padding: 20px 0;
  border-bottom: 1px solid #ddd;
}
.menu-A-read-wrap > div ul li dl {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 22px 0;
  border-bottom: 1px solid #ddd;
}

.menu-A-read-wrap > div ul li dl dt {
  width: 100%;
  margin-bottom: 10px;
}
.menu-A-read-wrap > div ul li dl dd {
  line-height: 1.7em;
  width: 100%;
}

.menu-A-read-wrap div.btn {
  margin-top: 50px;
  text-align: center;
}
.menu-A-read-wrap div.btn a {
  display: inline-block;
  text-align: center;
  font-size: 15px;
  background: #fff;
  color: #004e31;
  padding: 5px 25px;
  transition: all 0.2s;
  border: 1px solid #004e31;
  font-weight: 500;
}

@media (min-width: 768px) {
  .menu-A-read-wrap > div ul li dl {
    align-items: center;
  }
  .menu-A-read-wrap > div ul li dl.line3 {
    border-top: 1px solid #ddd;
  }
  .menu-A-read-wrap > div ul.line {
    border-bottom: 1px solid #ddd;
  }
  .menu-A-read-wrap > div ul li dl.line2 {
    border-bottom: none;
  }
  .menu-A-read-wrap > div ul.line4 {
    border-top: 1px solid #ddd;
  }
  .menu-A-read-wrap > div ul li:nth-child(1) {
    width: 180px;
    padding: 0;
    text-align: center;
    border-bottom: none;
  }
  .menu-A-read-wrap > div ul li:nth-child(2) {
    width: calc(100% - 200px);
  }
  .menu-A-read-wrap > div ul li {
    font-size: 15px;
  }
  .menu-A-read-wrap > div ul li dl dt {
    width: 80px;
    margin-bottom: 0;
  }
  .menu-A-read-wrap > div ul li dl dd {
    line-height: 1.7em;
    width: calc(100% - 90px);
  }
}

@media screen and (min-width: 1100px) {
  .menu-A-read-wrap > div ul li:nth-child(1) {
    width: 270px;
    padding: 0;
  }
  .menu-A-read-wrap > div ul li:nth-child(2) {
    width: calc(100% - 320px);
  }
}
</style>
